import { useState } from "react";

const iS = { width: "100%", padding: "10px 14px", marginBottom: 12, background: "#06060a", border: "1px solid #1f1f3a", borderRadius: 8, color: "#e0e0e0", fontSize: 14, outline: "none", boxSizing: "border-box", fontFamily: "inherit" };

export default function Signup({ onBack }) {
  const [form, setForm] = useState({ name: "", email: "", password: "", company_name: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!form.company_name.trim() || !form.email.trim() || !form.password) {
      setError("All fields are required.");
      setLoading(false);
      return;
    }
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters.");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch("/api/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Signup failed. Please try again.");
        setLoading(false);
        return;
      }

      setSuccess(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#08080c" }}>
        <div style={{ width: 380, padding: 36, background: "#0d0d12", borderRadius: 16, border: "1px solid #1f1f3a", textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>🎉</div>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#e0e0e0", marginBottom: 8 }}>You're all set!</h2>
          <p style={{ fontSize: 13, color: "#888", lineHeight: 1.6, marginBottom: 24 }}>
            Your account has been created. You can now sign in with your email and password.
          </p>
          <button
            onClick={onBack}
            style={{ width: "100%", padding: "10px 0", background: "linear-gradient(135deg, #6366f1, #4f46e5)", border: "none", borderRadius: 8, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}
          >Sign In</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#08080c" }}>
      <div style={{ width: 380, padding: 36, background: "#0d0d12", borderRadius: 16, border: "1px solid #1f1f3a" }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4, color: "#e0e0e0" }}>Clarifico</h1>
        <p style={{ fontSize: 13, color: "#555", marginBottom: 28 }}>Create your account</p>

        <form onSubmit={handleSignup}>
          <input
            value={form.company_name}
            onChange={set("company_name")}
            placeholder="Company name"
            style={iS}
          />
          <input
            value={form.name}
            onChange={set("name")}
            placeholder="Your name (optional)"
            style={iS}
          />
          <input
            type="email"
            value={form.email}
            onChange={set("email")}
            placeholder="Email"
            style={iS}
          />
          <input
            type="password"
            value={form.password}
            onChange={set("password")}
            placeholder="Password (min 8 characters)"
            style={iS}
          />

          {error && <p style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{error}</p>}

          <button
            type="submit"
            disabled={loading}
            style={{ width: "100%", padding: "10px 0", background: "linear-gradient(135deg, #6366f1, #4f46e5)", border: "none", borderRadius: 8, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", marginBottom: 12, opacity: loading ? 0.5 : 1 }}
          >{loading ? "Creating account..." : "Create Account"}</button>

          <button
            type="button"
            onClick={onBack}
            style={{ width: "100%", padding: "9px 0", background: "none", border: "1px solid #1f1f3a", borderRadius: 8, color: "#888", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}
          >Already have an account? Sign in</button>
        </form>

        <p style={{ fontSize: 10, color: "#333", marginTop: 16, lineHeight: 1.5, textAlign: "center" }}>
          By creating an account you agree to our Terms of Service. 14-day free trial on all plans.
        </p>
      </div>
    </div>
  );
}
